"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

require("./TaskChordBuilder.css");

var _abcjs = _interopRequireDefault(require("abcjs"));

var _MusicEditor = _interopRequireWildcard(require("./MusicEditor"));

var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback/AlertFeedback"));

var _Button = _interopRequireDefault(require("react-bootstrap/Button"));

var _CompletedContext = require("../CompletedContext");

var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));

var _reactBootstrap = require("react-bootstrap");

// import axios from 'axios';
var DEBUG = false;

function splitNotation(notation, vb) {
  var split = notation;

  if (vb) {
    split = notation.split(/(?=[A-Za-z|])/);
  } else {
    split = notation.replace('[', '').replace(']', '').split(/(?=[A-Za-z|])/);
  }

  for (var i = 0; i < split.length; i++) {
    // split[i] = split[i].replace(/\s/g, "")
    if ('^^__'.includes(split[i].slice(-2))) {
      split[i + 1] = split[i].slice(-2) + split[i + 1];
      split[i] = split[i].slice(0, -2);
    } else if ('^_='.includes(split[i].slice(-1))) {
      split[i + 1] = split[i].slice(-1) + split[i + 1];
      split[i] = split[i].slice(0, -1);
    }
  }

  split = split.filter(function (entry) {
    return entry !== " ";
  });
  if (split[0] === '') split.splice(split.indexOf(''), 1);
  return split;
}

var TaskChordBuilder = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskChordBuilder, _React$Component);

  var _super = (0, _createSuper2.default)(TaskChordBuilder);

  function TaskChordBuilder(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskChordBuilder);
    _this = _super.call(this, props);

    _this.submitChord = function () {
      var parse = _abcjs.default.parseOnly(_this.state.precursor + _this.state.notation);

      var server_notation = "";

      if (parse[0].lines[0].staff[0].voices[0][0].pitches) {
        var clef = parse[0].lines[0].staff[0].clef.type;
        server_notation = parse[0].lines[0].staff[0].voices[0][0].pitches.map(function (note) {
          if (clef === "treble") {
            return (note.accidental ? _MusicEditor.accidentals[note.accidental] : "") + (0, _MusicEditor.get_treble_pitch)(note.pitch);
          } else if (clef === "bass") {
            return (note.accidental ? _MusicEditor.accidentals[note.accidental] : "") + (0, _MusicEditor.get_bass_pitch)(note.verticalPos);
          } else if (clef === "alto") {
            return (note.accidental ? _MusicEditor.accidentals[note.accidental] : "") + (0, _MusicEditor.get_alto_pitch)(note.verticalPos);
          }

          return "";
        });

        if (_this.props.answers) {
          var found = false;

          for (var i = 0; i < _this.props.answers.length; ++i) {
            var answer = splitNotation(_this.props.answers[i].answer);

            if (_this.arraysAreIdentical(server_notation.sort(), answer.sort())) {
              found = true;

              _this.setState({
                completed: _this.props.answers[i].correct,
                showAnswer: _this.state.correct !== undefined,
                correct: _this.props.answers[i].correct,
                showModal: !_this.props.answers[i].correct,
                showNag: _this.state.showAnswer,
                feedback: _this.props.answers[i].feedback
              });

              if (!_this.props.answers[i].correct) {
                _this.setState({
                  showFeedback: true
                });
              }
            }
          }

          if (!found) {
            _this.setState({
              completed: false,
              showAnswer: _this.state.correct !== undefined,
              correct: false,
              showModal: true,
              showNag: _this.state.showAnswer,
              feedback: _this.props.feedbackIncorrect,
              showFeedback: true
            });
          }
        } else {
          var correct = splitNotation(_this.state.correctAnswer);

          var match = _this.arraysAreIdentical(server_notation.sort(), correct.sort());

          _this.setState({
            completed: match,
            showAnswer: _this.state.correct !== undefined,
            correct: match,
            showModal: !match,
            showNag: _this.state.showAnswer,
            feedback: match ? _this.props.feedbackCorrect : _this.props.feedbackIncorrect
          });

          if (!match) {
            _this.setState({
              showFeedback: true
            });
          }
        }
      }
    };

    DEBUG && console.log("ChordBuilder constructor");
    _this.state = props.state || {};
    var musicInitial = _this.props.musicInitial;
    if (musicInitial === "[]" || musicInitial === "") musicInitial = 'z';

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = false;
      _this.state.showAnswer = false;
      _this.state.notation = _this.props.notation || _this.props.musicInitial || _this.props.notation_initial || "[z]";
      _this.state.notation = musicInitial || _this.state.notation;
      _this.state.correctAnswer = _this.props.correct || _this.props.answers.find(function (a) {
        return a.correct;
      }).answer;
      _this.state.musicInitial = musicInitial;
      _this.state.precursor = _this.props.musicConfiguration.split(';').join('\n') + '\n';
    }

    _this.musiceditor = /*#__PURE__*/_react.default.createRef();
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TaskChordBuilder, [{
    key: "arraysAreIdentical",
    value: function arraysAreIdentical(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      for (var i = 0, len = arr1.length; i < len; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "checkIfNoteInNotation",
    value: function checkIfNoteInNotation(correctNote, notation) {
      var _this2 = this;

      var parsedResponse = _abcjs.default.parseOnly(this.state.precursor + notation);

      var t = 0;
      if (!parsedResponse[0].lines[0].staff[0].voices[0][0].pitches) return;
      parsedResponse[0].lines[0].staff[0].voices[0][0].pitches.forEach(function (notationNote) {
        if (_this2.arraysAreIdentical(Object.values(notationNote), Object.values(correctNote))) t++;
      });
      return t;
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      DEBUG && console.log("TaskChordBuilder componentDidMount"); // Notify the parent of our completion status

      this.context.registerTask(function (id) {
        _this3.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      var _this$props$answers;

      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }

      var musicInitial = this.props.musicInitial;
      if (musicInitial === "[]" || musicInitial === "") musicInitial = 'z';
      this.state.correctAnswer = this.props.correct || ((_this$props$answers = this.props.answers) === null || _this$props$answers === void 0 ? void 0 : _this$props$answers.find(function (a) {
        return a.correct;
      }).answer);
      this.state.musicInitial = musicInitial;
      this.state.precursor = this.props.musicConfiguration.split(';').join('\n') + '\n';

      if (prevprops.musicInitial !== this.props.musicInitial) {
        DEBUG && console.log("ChordBuilder componentDidUpdate props.musicInitial changed");
        this.state.notation = this.props.notation || this.props.musicInitial || this.props.notation_initial || "[z]";
        this.state.notation = musicInitial || this.state.notation;
      }
    }
  }, {
    key: "onChange",
    value: function onChange(newNotation) {
      this.setState({
        notation: newNotation
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$zoom,
          _this4 = this,
          _this$props$zoom2,
          _this$props$feedbackI;

      DEBUG && console.log("TaskChordBuilder render");
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task task-chord-builder"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "chord-builder-container",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "chord-builder",
        ref: this.ref
      }, this.state.completed && !this.state.correct && /*#__PURE__*/_react.default.createElement("p", {
        style: {
          padding: "10px",
          backgroundColor: "#f8d7da",
          borderRadius: "5px",
          border: "1px #f5c6cb solid"
        }
      }, "Your Submission:"), /*#__PURE__*/_react.default.createElement(_MusicEditor.default, Object.assign({
        ref: this.musiceditor
      }, this.props, this.state, {
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper,
        addClasses: true,
        addHotspots: true,
        accidentals: true,
        chordMode: true,
        millisecondsPerMeasure: this.props.musicDuration,
        zoom: (_this$props$zoom = this.props.zoom) !== null && _this$props$zoom !== void 0 ? _this$props$zoom : 4,
        precursor: this.state.precursor,
        notation: this.state.notation,
        answer: this.state.answer,
        onChange: this.onChange,
        completed: this.state.completed
      }))), !this.state.completed && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "dark",
        className: "sb-action-button",
        disabled: this.state.correct,
        style: {
          float: "left"
        },
        onClick: function onClick() {
          var newNotation = _this4.state.musicInitial;

          _this4.musiceditor.current.setState({
            accidental: ""
          });

          _this4.setState({
            notation: newNotation,
            reset: true
          });
        }
      }, " Clear Staff "), /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "dark",
        className: "sb-action-button",
        disabled: this.state.correct || this.state.notation.trim() === "z",
        style: {
          float: "right"
        },
        onClick: function onClick() {
          var newChord = _this4.state.notation.slice();

          _this4.setState({
            lastChordNotation: newChord
          });

          _this4.submitChord();
        }
      }, " Submit "))), this.state.showAnswer && !this.state.completed && /*#__PURE__*/_react.default.createElement("div", {
        className: "scale-builder-container",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          margin: "10px 0px",
          padding: "10px",
          backgroundColor: "#d4edda",
          borderRadius: "5px",
          border: "1px c3e6cb solid"
        }
      }, "The correct answer is shown below. Update your answer to match it to move on."), /*#__PURE__*/_react.default.createElement(_MusicEditor.default, Object.assign({
        ref: this.musiceditor
      }, this.props, this.state, {
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper,
        addClasses: true,
        addHotspots: true,
        hideHint: true,
        chordMode: true,
        millisecondsPerMeasure: this.props.musicDuration,
        zoom: (_this$props$zoom2 = this.props.zoom) !== null && _this$props$zoom2 !== void 0 ? _this$props$zoom2 : 4,
        precursor: this.state.precursor,
        notation: this.state.correctAnswer,
        answer: this.state.answer,
        onChange: function onChange() {},
        completed: this.state.completed
      }))), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showModal,
        onHide: function onHide() {
          _this4.setState({
            showModal: false
          });
        }
      }, this.state.feedback), (this.state.correct || this.state.showNag) && /*#__PURE__*/_react.default.createElement(_AlertFeedback.default, {
        incorrect: !this.state.correct,
        feedback: this.state.correct ? this.state.feedback : (_this$props$feedbackI = this.props.feedbackIncorrect2) !== null && _this$props$feedbackI !== void 0 ? _this$props$feedbackI : "Input the correct answer to move on."
      }));
    }
  }]);
  return TaskChordBuilder;
}(_react.default.Component);

TaskChordBuilder.contextType = _CompletedContext.CompletedContext;
var _default = TaskChordBuilder;
exports.default = _default;